import { Info } from "lucide-react";

export default function GuideBanner({ title, text }) {
  return (
    <div style={{
      background: "linear-gradient(135deg, #f0fdfa, #ecfdf5)",
      borderRadius: 10, padding: "14px 18px",
      border: "1px solid #99f6e4", marginBottom: 16,
      display: "flex", gap: 12, alignItems: "flex-start",
    }}>
      <div style={{
        width: 32, height: 32, borderRadius: 8, background: "#0d9488",
        display: "flex", alignItems: "center", justifyContent: "center",
        flexShrink: 0, marginTop: 2,
      }}>
        <Info size={16} color="#fff" />
      </div>
      <div>
        <div style={{ fontSize: 13, fontWeight: 700, color: "#0f4f46", marginBottom: 3 }}>
          {title}
        </div>
        <div style={{ fontSize: 12, color: "#115e59", lineHeight: 1.5 }}>{text}</div>
      </div>
    </div>
  );
}
